/* Dawn-style variant media updater via section rendering */
(function () {
  "use strict";
  if (window.VariantMediaFilter) return;
  var vmfRequests = Object.create(null);

  function getGalleryId(sectionId) {
    return "ProductMediaGallery-" + sectionId;
  }

  function enforceThumbRail(gallery) {
    var rail = gallery?.querySelector(".productView-for:not(.mobile)");
    if (!rail) return;
    if (rail.classList.contains("slick-initialized")) return;
    var items = rail.querySelectorAll(":scope > .productView-thumbnail");
    var needsStatic = items.length <= 1;
    if (needsStatic) {
      rail.classList.add("productView-for-static");
      rail.style.opacity = "1";
      rail.style.width = "100%";
      items.forEach(function (item) {
        item.style.width = "100%";
        item.style.display = "block";
      });
      return;
    }

    rail.classList.remove("productView-for-static");
    rail.style.width = "";
    rail.querySelectorAll(".productView-thumbnail").forEach(function (item) {
      item.style.width = "";
      item.style.display = "";
    });
  }

  function findFeaturedMediaId(productDetails, variantId) {
    var picker = productDetails?.querySelector("variant-radios, variant-selects");
    var json = picker?.querySelector('script[type="application/json"]');
    if (!json) return null;
    try {
      var variants = JSON.parse(json.textContent);
      var variant = variants.find(function (v) {
        return String(v.id) === String(variantId);
      });
      return variant?.featured_media?.id ? String(variant.featured_media.id) : null;
    } catch (e) {
      return null;
    }
  }

  function moveFeaturedFirst(gallery, featuredMediaId) {
    if (!gallery || !featuredMediaId) return;

    var nav = gallery.querySelector(".productView-nav");
    if (nav) {
      var navSlide = Array.from(nav.querySelectorAll(":scope > .productView-image")).find(function (slide) {
        return !!slide.querySelector('.product-single__media[data-media-id="' + featuredMediaId + '"]');
      });
      if (navSlide && nav.firstElementChild !== navSlide) {
        nav.prepend(navSlide);
      }
    }

    var rail = gallery.querySelector(".productView-for:not(.mobile)");
    if (rail) {
      var thumb = Array.from(rail.querySelectorAll(":scope > .productView-thumbnail")).find(function (item) {
        var mediaId = item.getAttribute("data-media-id") || "";
        return mediaId === featuredMediaId || mediaId.endsWith("-" + featuredMediaId);
      });
      if (thumb && rail.firstElementChild !== thumb) {
        rail.prepend(thumb);
      }
    }
  }

  function setActiveToFirst(gallery) {
    var $ = window.jQuery;
    var rail = gallery?.querySelector(".productView-for:not(.mobile)");
    if (rail) {
      rail.querySelectorAll(".productView-thumbnail").forEach(function (el) {
        el.classList.remove("slick-current");
      });
      rail.querySelector(".productView-thumbnail")?.classList.add("slick-current");
    }

    var nav = gallery?.querySelector(".productView-nav");
    if ($ && nav && nav.classList.contains("slick-initialized")) {
      try {
        $(nav).slick("slickGoTo", 0, true);
      } catch (e) {
        /* noop */
      }
    }
  }

  function updateSlickTeardown(gallery) {
    var $ = window.jQuery;
    if (!$) return;

    [".productView-nav", ".productView-for"].forEach(function (selector) {
      var $el = $(gallery).find(selector);
      if ($el.hasClass("slick-initialized")) {
        try {
          $el.slick("unslick");
        } catch (e) {
          /* noop */
        }
      }
    });
  }

  function mediaIdFromThumb(thumb) {
    var raw = thumb?.getAttribute("data-media-id") || "";
    if (!raw) return null;
    var parts = raw.split("-");
    return parts[parts.length - 1] || null;
  }

  function findMainIndexByMediaId(gallery, mediaId) {
    if (!gallery || !mediaId) return -1;
    var slides = Array.from(gallery.querySelectorAll(".productView-nav .productView-image"));
    return slides.findIndex(function (slide) {
      var media = slide.querySelector(".product-single__media[data-media-id]");
      var id = media?.getAttribute("data-media-id") || slide.getAttribute("data-media-id");
      return String(id) === String(mediaId);
    });
  }

  function findSlickIndexByMediaId(gallery, mediaId) {
    if (!gallery || !mediaId) return -1;
    var nav = gallery.querySelector(".productView-nav");
    if (!nav) return -1;
    var target = nav.querySelector(
      '.slick-slide:not(.slick-cloned) .product-single__media[data-media-id="' + mediaId + '"]'
    );
    if (!target) return -1;
    var slide = target.closest(".slick-slide");
    if (!slide) return -1;
    var slickIndex = parseInt(slide.getAttribute("data-slick-index"), 10);
    return Number.isNaN(slickIndex) ? -1 : slickIndex;
  }

  function showMainByMediaId(gallery, mediaId) {
    var index = findMainIndexByMediaId(gallery, mediaId);
    if (index < 0) return;
    var slides = Array.from(gallery.querySelectorAll(".productView-nav .productView-image"));
    slides.forEach(function (slide, i) {
      slide.style.display = i === index ? "" : "none";
    });
  }

  function bindThumbnailNavigation(gallery) {
    var rail = gallery?.querySelector(".productView-for:not(.mobile)");
    if (!rail || rail.dataset.vmfThumbBound === "true") return;
    rail.dataset.vmfThumbBound = "true";

    rail.addEventListener("click", function (event) {
      if (rail.dataset.vmfDragJustEnded === "true") {
        event.preventDefault();
        rail.dataset.vmfDragJustEnded = "false";
        return;
      }
      var thumb = event.target.closest(".productView-thumbnail");
      if (!thumb || !rail.contains(thumb)) return;
      event.preventDefault();

      var mediaId = mediaIdFromThumb(thumb);
      if (!mediaId) return;
      rail.querySelectorAll(".productView-thumbnail").forEach(function (el) {
        el.classList.remove("slick-current");
      });
      thumb.classList.add("slick-current");

      var $ = window.jQuery;
      var nav = gallery.querySelector(".productView-nav");
      if ($ && nav && nav.classList.contains("slick-initialized")) {
        var slickIndex = findSlickIndexByMediaId(gallery, mediaId);
        if (slickIndex >= 0) {
          try {
            $(nav).slick("slickGoTo", slickIndex, false);
            window.setTimeout(function () {
              try {
                $(nav).slick("setPosition");
              } catch (e) {
                /* noop */
              }
            }, 0);
            return;
          } catch (e) {
            /* noop */
          }
        }
      }

      showMainByMediaId(gallery, mediaId);
    });
  }

  function ensureVerticalThumbSlick(gallery) {
    var $ = window.jQuery;
    if (!$) return;
    if (window.innerWidth < 1025) return;

    var rail = gallery?.querySelector(".productView-for:not(.mobile)");
    var nav = gallery?.querySelector(".productView-nav");
    if (!rail || !nav) return;

    var $rail = $(rail);
    var thumbs = rail.querySelectorAll(":scope > .productView-thumbnail");
    if (thumbs.length <= 1 || $rail.hasClass("slick-initialized")) return;

    var thumbnailToShow = Math.min(parseInt(rail.getAttribute("data-max-thumbnail-to-show") || "6", 10), thumbs.length);
    var thumbVertical = window.innerWidth > 1024 && thumbnailToShow > 2;

    $rail.slick({
      slidesToShow: thumbnailToShow,
      slidesToScroll: 1,
      asNavFor: false,
      arrows: true,
      dots: false,
      swipe: true,
      draggable: true,
      touchMove: true,
      swipeToSlide: true,
      waitForAnimate: false,
      touchThreshold: 12,
      adaptiveHeight: false,
      focusOnSelect: false,
      vertical: thumbVertical,
      verticalSwiping: thumbVertical,
      infinite: false,
      nextArrow: window.arrows?.icon_next,
      prevArrow: window.arrows?.icon_prev,
      rtl: window.rtl_slick,
      responsive: [
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: thumbnailToShow > 3 ? thumbnailToShow - 1 : thumbnailToShow,
            slidesToScroll: 1,
            vertical: thumbVertical,
            verticalSwiping: thumbVertical,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            vertical: false,
            verticalSwiping: false,
            rtl: window.rtl_slick,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 1,
            vertical: false,
            verticalSwiping: false,
            rtl: window.rtl_slick,
          },
        },
      ],
    });

    $rail.off("wheel.vmfRail").on("wheel.vmfRail", ".slick-list", function (e) {
      if (window.innerWidth < 1025 || !$rail.hasClass("slick-initialized")) return;
      e.preventDefault();
      var dy = e.originalEvent?.deltaY || 0;
      var slick = $rail.slick("getSlick");
      if (!slick || !dy) return;
      var maxStart = Math.max(0, slick.slideCount - slick.options.slidesToShow);
      var step = Math.max(1, Math.round(Math.abs(dy) / 80));
      var next = dy > 0
        ? Math.min(maxStart, slick.currentSlide + step)
        : Math.max(0, slick.currentSlide - step);
      $rail.slick("slickGoTo", next, false);
    });

    var dragStartY = null;
    var dragStartSlide = null;
    var dragMoved = false;
    $rail.off("mousedown.vmfDrag").on("mousedown.vmfDrag", ".slick-list", function (e) {
      if (window.innerWidth < 1025 || !$rail.hasClass("slick-initialized") || e.button !== 0) return;
      var slick = $rail.slick("getSlick");
      if (!slick) return;
      dragStartY = e.clientY;
      dragStartSlide = slick.currentSlide;
      dragMoved = false;
    });

    $rail.off("mousemove.vmfDrag").on("mousemove.vmfDrag", ".slick-list", function (e) {
      if (dragStartY === null) return;
      if (Math.abs(e.clientY - dragStartY) > 6) {
        dragMoved = true;
      }
    });

    $(document).off("mouseup.vmfDrag").on("mouseup.vmfDrag", function (e) {
      if (dragStartY === null || dragStartSlide === null) return;
      var slick = $rail.hasClass("slick-initialized") ? $rail.slick("getSlick") : null;
      var startY = dragStartY;
      var startSlide = dragStartSlide;
      var moved = dragMoved;
      dragStartY = null;
      dragStartSlide = null;
      dragMoved = false;
      if (!slick || !moved) return;
      var sampleThumb = $rail.find(".productView-thumbnail:visible").first();
      var thumbHeight = Math.max(32, Math.round(sampleThumb.outerHeight(true) || 54));
      var deltaY = startY - e.clientY;
      var step = Math.max(1, Math.round(Math.abs(deltaY) / thumbHeight));
      var direction = deltaY > 0 ? 1 : -1;
      var maxStart = Math.max(0, slick.slideCount - slick.options.slidesToShow);
      var next = Math.max(0, Math.min(maxStart, startSlide + direction * step));
      rail.dataset.vmfDragJustEnded = "true";
      $rail.slick("slickGoTo", next, false);
      window.setTimeout(function () {
        rail.dataset.vmfDragJustEnded = "false";
      }, 0);
    });

    $rail.off("click.vmfEdge").on("click.vmfEdge", ".productView-thumbnail", function () {
      if (!$rail.hasClass("slick-initialized")) return;
      var thumbSlick = $rail.slick("getSlick");
      var list = $rail.find(".slick-list").get(0);
      if (!thumbSlick || !list) return;
      var listRect = list.getBoundingClientRect();
      var thumbRect = this.getBoundingClientRect();
      var edgeThreshold = Math.max(thumbRect.height * 1.25, 56);
      var isNearTop = thumbRect.top <= listRect.top + edgeThreshold;
      var isNearBottom = thumbRect.bottom >= listRect.bottom - edgeThreshold;
      var slide = this.closest(".slick-slide");
      var targetIndex = parseInt(slide?.getAttribute("data-slick-index"), 10);
      if (Number.isNaN(targetIndex)) return;
      var visibleCount = Math.max(1, parseInt(thumbSlick.options.slidesToShow, 10) || 1);
      var maxStart = Math.max(0, thumbSlick.slideCount - visibleCount);
      var edgeInset = 0;
      var nextStart = thumbSlick.currentSlide;
      if (isNearTop) {
        nextStart = Math.max(0, targetIndex - edgeInset);
        if (nextStart === thumbSlick.currentSlide && thumbSlick.currentSlide > 0 && targetIndex <= thumbSlick.currentSlide) {
          nextStart = thumbSlick.currentSlide - 1;
        }
      } else if (isNearBottom) {
        nextStart = Math.min(maxStart, targetIndex - visibleCount + 1 + edgeInset);
        if (nextStart === thumbSlick.currentSlide && thumbSlick.currentSlide < maxStart && targetIndex >= thumbSlick.currentSlide + visibleCount - 1) {
          nextStart = thumbSlick.currentSlide + 1;
        }
      }
      if (nextStart !== thumbSlick.currentSlide) {
        $rail.slick("slickGoTo", nextStart, false);
        window.requestAnimationFrame(function () {
          rail.querySelectorAll(".productView-thumbnail").forEach(function (el) {
            el.classList.remove("slick-current");
          });
          this.classList.add("slick-current");
        }.bind(this));
      }
    });
  }

  function syncDesktopRailHeight(gallery) {
    if (!gallery) return;
    var wrapperAny = gallery.closest(".productView")?.querySelector(".productView-thumbnail-wrapper");
    if (window.innerWidth < 1025) {
      if (wrapperAny) {
        wrapperAny.style.height = "";
        wrapperAny.style.maxHeight = "";
        wrapperAny.style.overflow = "";
      }
      return;
    }
    var scope = gallery.closest(".productView.layout-1, .productView.layout-2");
    if (!scope) return;
    var nav = scope.querySelector(".productView-nav");
    var wrapper = scope.querySelector(".productView-thumbnail-wrapper");
    if (!nav || !wrapper) return;
    var h = Math.round(nav.getBoundingClientRect().height);
    if (h > 0) {
      wrapper.style.height = h + "px";
      wrapper.style.maxHeight = h + "px";
      wrapper.style.overflow = "hidden";
    }
  }

  function scheduleRailLayoutSync(gallery) {
    var $ = window.jQuery;
    if (!$ || !gallery) return;
    if (window.innerWidth < 1025) {
      syncDesktopRailHeight(gallery);
      return;
    }
    var rail = gallery.querySelector(".productView-for:not(.mobile)");
    if (!rail) return;
    var $rail = $(rail);
    window.requestAnimationFrame(function () {
      if ($rail.hasClass("slick-initialized")) {
        try {
          $rail.slick("setPosition");
        } catch (e) {
          /* noop */
        }
      } else {
        ensureVerticalThumbSlick(gallery);
      }
      syncDesktopRailHeight(gallery);
    });
  }

  function ensureMobileGallery(gallery) {
    if (!gallery || window.innerWidth >= 768) return;
    var $ = window.jQuery;
    if (!$) return;

    var nav = gallery.querySelector(".productView-nav");
    var rail = gallery.querySelector(".productView-for:not(.mobile)");
    if (!nav || !rail) return;

    var $nav = $(nav);
    var $rail = $(rail);

    if (!$nav.hasClass("slick-initialized")) {
      $nav.slick({
        fade: false,
        dots: false,
        arrows: !!$nav.data("arrows-mobi"),
        infinite: true,
        swipe: true,
        draggable: true,
        touchMove: true,
        waitForAnimate: false,
        speed: 280,
        cssEase: "ease-out",
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: false,
        nextArrow: window.arrows?.icon_next,
        prevArrow: window.arrows?.icon_prev,
        rtl: window.rtl_slick,
      });
    }

    if ($rail.hasClass("slick-initialized")) {
      try {
        $rail.slick("unslick");
      } catch (e) {
        /* noop */
      }
    }

    $rail.addClass("native-thumb-scroll");

    var syncActiveThumb = function (slideIndex) {
      var index = Number.isInteger(slideIndex) ? slideIndex : 0;
      var thumbs = $rail.find(".productView-thumbnail");
      var activeThumb = thumbs.eq(index);
      thumbs.removeClass("slick-current");
      activeThumb.addClass("slick-current");
    };

    var ensureThumbVisible = function (thumbEl) {
      if (!thumbEl || typeof thumbEl.scrollIntoView !== "function") return;
      var railRect = rail.getBoundingClientRect();
      var thumbRect = thumbEl.getBoundingClientRect();
      var edgeThreshold = Math.max(12, Math.round(thumbRect.width * 0.35));
      var isOutLeft = thumbRect.left < railRect.left + edgeThreshold;
      var isOutRight = thumbRect.right > railRect.right - edgeThreshold;
      if (isOutLeft || isOutRight) {
        thumbEl.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" });
      }
    };

    var scrollByThumbs = function (dir) {
      var sampleThumb = $rail.find(".productView-thumbnail").first();
      var thumbWidth = Math.max(32, Math.round(sampleThumb.outerWidth(true) || 52));
      rail.scrollBy({ left: dir * thumbWidth, behavior: "smooth" });
    };

    $rail.off("click.vmfNative").on("click.vmfNative", ".productView-thumbnail", function (e) {
      e.preventDefault();
      var thumbRect = this.getBoundingClientRect();
      var railRect = rail.getBoundingClientRect();
      var edgeThreshold = Math.max(12, Math.round(thumbRect.width * 0.35));
      var nearLeft = thumbRect.left <= railRect.left + edgeThreshold;
      var nearRight = thumbRect.right >= railRect.right - edgeThreshold;
      var targetIndex = $rail.find(".productView-thumbnail").index(this);
      $nav.slick("slickGoTo", targetIndex);
      syncActiveThumb(targetIndex);
      if (nearLeft || nearRight) scrollByThumbs(nearRight ? 1 : -1);
      else ensureThumbVisible(this);
    });

    $nav.off("afterChange.vmfNative").on("afterChange.vmfNative", function (event, slick, currentSlide) {
      syncActiveThumb(currentSlide);
      ensureThumbVisible($rail.find(".productView-thumbnail").eq(currentSlide).get(0));
    });

    var currentSlide = $nav.hasClass("slick-initialized") ? $nav.slick("getSlick")?.currentSlide || 0 : 0;
    syncActiveThumb(currentSlide);
  }

  function alignInitialFeaturedMedia(gallery) {
    if (!gallery) return;
    var productDetails = gallery.closest(".product-details");
    if (!productDetails || productDetails.dataset.vmfEnabled !== "true") return;
    var variantId = productDetails.querySelector('input[name="id"]')?.value
      || new URLSearchParams(window.location.search).get("variant");
    if (!variantId) return;
    var featuredMediaId = findFeaturedMediaId(productDetails, variantId);
    if (!featuredMediaId) return;

    var $ = window.jQuery;
    var nav = gallery.querySelector(".productView-nav");
    if ($ && nav && nav.classList.contains("slick-initialized")) {
      var slickIndex = findSlickIndexByMediaId(gallery, featuredMediaId);
      if (slickIndex >= 0) {
        try {
          $(nav).slick("slickGoTo", slickIndex, true);
        } catch (e) {
          /* noop */
        }
      }
      var rail = gallery.querySelector(".productView-for:not(.mobile)");
      if (rail) {
        rail.querySelectorAll(".productView-thumbnail").forEach(function (el) {
          el.classList.remove("slick-current");
        });
        var featuredThumb = Array.from(rail.querySelectorAll(".productView-thumbnail")).find(function (item) {
          var mediaId = item.getAttribute("data-media-id") || "";
          return mediaId === featuredMediaId || mediaId.endsWith("-" + featuredMediaId);
        });
        featuredThumb?.classList.add("slick-current");
      }
      return;
    }

    moveFeaturedFirst(gallery, featuredMediaId);
    setActiveToFirst(gallery);
  }

  function bindGalleryLayoutObservers(gallery) {
    if (!gallery || gallery.dataset.vmfLayoutBound === "true") return;
    gallery.dataset.vmfLayoutBound = "true";

    var navImages = gallery.querySelectorAll(".productView-nav img");
    navImages.forEach(function (img) {
      if (img.complete) return;
      img.addEventListener(
        "load",
        function () {
          scheduleRailLayoutSync(gallery);
        },
        { once: true }
      );
    });
  }

  function afterGallerySwap(productDetails, sectionId, featuredMediaId) {
    var liveGallery = document.getElementById(getGalleryId(sectionId));
    if (!liveGallery) return;
    moveFeaturedFirst(liveGallery, featuredMediaId);
    setActiveToFirst(liveGallery);
    bindThumbnailNavigation(liveGallery);
    bindGalleryLayoutObservers(liveGallery);
    scheduleRailLayoutSync(liveGallery);
    ensureMobileGallery(liveGallery);
  }

  async function updateGallery(productDetails, variantId) {
    if (!productDetails || !variantId) return;

    var sectionId = productDetails.dataset.sectionId;
    var productUrl = productDetails.dataset.productUrl;
    if (!sectionId || !productUrl) return;

    var url = new URL(productUrl, window.location.origin);
    url.searchParams.set("variant", String(variantId));
    url.searchParams.set("section_id", String(sectionId));
    var previewThemeId = new URLSearchParams(window.location.search).get("preview_theme_id");
    if (previewThemeId) {
      url.searchParams.set("preview_theme_id", previewThemeId);
    }

    var key = String(sectionId);
    if (vmfRequests[key]?.controller) {
      try {
        vmfRequests[key].controller.abort();
      } catch (e) {
        /* noop */
      }
    }
    var requestId = (vmfRequests[key]?.id || 0) + 1;
    var controller = new AbortController();
    vmfRequests[key] = { id: requestId, controller: controller };

    var featuredMediaId = findFeaturedMediaId(productDetails, variantId);
    var response;
    try {
      response = await fetch(url.toString(), { signal: controller.signal });
    } catch (e) {
      if (e?.name === "AbortError") return;
      return;
    }
    if (!response.ok) return;
    if (!vmfRequests[key] || vmfRequests[key].id !== requestId) return;

    var parser = new DOMParser();
    var html = parser.parseFromString(await response.text(), "text/html");
    var freshGallery = html.getElementById(getGalleryId(sectionId));
    var currentGallery = document.getElementById(getGalleryId(sectionId));
    if (!freshGallery || !currentGallery) return;

    updateSlickTeardown(currentGallery);
    currentGallery.replaceWith(freshGallery);
    moveFeaturedFirst(freshGallery, featuredMediaId);
    enforceThumbRail(freshGallery);
    setActiveToFirst(freshGallery);
    bindThumbnailNavigation(freshGallery);
    bindGalleryLayoutObservers(freshGallery);
    scheduleRailLayoutSync(freshGallery);

    var $ = window.jQuery;
    if (window.halo && $) {
      var scopeEl = freshGallery.closest(".halo-productView, .productView");
      var $scope = scopeEl ? $(scopeEl) : $(productDetails).find(".halo-productView, .productView").first();
      try {
        window.halo.productImageGallery($scope);
      } catch (error) {
        // Keep VMF flow alive even if theme gallery init throws once.
      }
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          afterGallerySwap(productDetails, sectionId, featuredMediaId);
          var liveGallery = document.getElementById(getGalleryId(sectionId));
          var rail = liveGallery?.querySelector(".productView-for:not(.mobile)");
          if (rail && rail.querySelectorAll(":scope > .productView-thumbnail").length > 1 && !rail.classList.contains("slick-initialized")) {
            ensureVerticalThumbSlick(liveGallery);
          }
          ensureMobileGallery(liveGallery);
        });
      });
    } else {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          afterGallerySwap(productDetails, sectionId, featuredMediaId);
          var liveGallery = document.getElementById(getGalleryId(sectionId));
          ensureVerticalThumbSlick(liveGallery);
          ensureMobileGallery(liveGallery);
        });
      });
    }
  }

  window.VariantMediaFilter = {
    updateGallery: updateGallery,
  };

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".productView-media-gallery").forEach(function (gallery) {
      alignInitialFeaturedMedia(gallery);
      enforceThumbRail(gallery);
      bindThumbnailNavigation(gallery);
      bindGalleryLayoutObservers(gallery);
      scheduleRailLayoutSync(gallery);
      ensureMobileGallery(gallery);
    });
  });
})();
